// extracted by mini-css-extract-plugin
var _1 = "modal_cancel_button__G9AM9";
var _2 = "modal_modal_method__--q+G";
var _3 = "modal_ok_button__Jd8XX";
var _4 = "1100";
export { _1 as "cancel_button", _2 as "modal_method", _3 as "ok_button", _4 as "zIndex" }
